import { render } from "./EditableField.vue?vue&type=template&id=ca4a3cb0"
import script from "./EditableField.vue?vue&type=script&lang=js"
export * from "./EditableField.vue?vue&type=script&lang=js"

import "./EditableField.vue?vue&type=style&index=0&id=ca4a3cb0&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__